<app-error-page title="There's been a glitch..." (onAction)="refreshPage()">
    <p>We've got notified about the problem. Our engineers are working hard to resolve it asap.</p>
    <p>We genuinely appreciate your patience! 🌿</p>
</app-error-page>
